export enum OrderStatusEnum {
  waiting = 'waiting',
  approved = 'approved',
  rejected = 'rejected',
}
